/* QW2 reuses Focal's drawer, focus trap, overlay and toggle buttons. */
(() => {
  const selectedSize = (variant, position) => variant?.options?.[Number(position) - 1] || '';
  const matchingRow = (chart, value) => Array.from(chart?.querySelectorAll('[data-qw2-chart-row]') || []).find(row => {
    let aliases = [];
    try { aliases = JSON.parse(row.dataset.optionValues || '[]') || []; } catch (_) { /* Treat invalid optional aliases as empty. */ }
    return row.dataset.size === value || aliases.includes(value);
  });

  class SizeChart extends customElements.get('drawer-content') {
    connectedCallback() {
      super.connectedCallback();
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.form = document.getElementById(this.getAttribute('form-id'));
      this.highlight(this.currentSize());
      this.addEventListener('openable-element:open', () => {
        this.highlight(this.currentSize());
        document.body.classList.add('qw2-size-chart-open');
        if (!Shopify.designMode && history.state?.qw2SizeChart !== this.id) {
          history.pushState({ ...history.state, qw2SizeChart: this.id }, '', location.href);
        }
      }, { signal });
      this.addEventListener('openable-element:close', () => {
        document.body.classList.remove('qw2-size-chart-open');
        if (!this.closingFromHistory && history.state?.qw2SizeChart === this.id) history.back();
      }, { signal });
      window.addEventListener('popstate', () => {
        if (this.open && history.state?.qw2SizeChart !== this.id) {
          this.closingFromHistory = true;
          this.open = false;
          this.closingFromHistory = false;
        }
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.open) {
        this.open = false;
        document.documentElement.classList.remove('lock-all');
      }
      document.body.classList.remove('qw2-size-chart-open');
      super.disconnectedCallback();
    }
    currentSize() {
      const control = Array.from(this.form?.elements || []).find(input => input.name === 'option' + this.getAttribute('size-position') && (input.tagName === 'SELECT' || input.checked));
      return control?.value || '';
    }
    highlight(value) {
      this.dataset.selectedSize = value;
      const current = value ? matchingRow(this, value) : null;
      this.querySelectorAll('[data-qw2-chart-row]').forEach(row => {
        if (row === current) row.setAttribute('aria-current', 'true');
        else row.removeAttribute('aria-current');
      });
    }
  }
  customElements.define('qw2-size-chart', SizeChart);

  class ProductDetails extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const form = document.getElementById(this.getAttribute('form-id'));
      form?.addEventListener('variant:changed', event => {
        const value = selectedSize(event.detail.variant, this.getAttribute('size-position'));
        const chart = document.getElementById(this.getAttribute('chart-id'));
        chart?.highlight?.(value);
        const row = value ? matchingRow(chart, value) : null;
        const contents = row?.dataset.contents?.trim() || this.dataset.defaultContents || '';
        const line = this.querySelector('[data-qw2-contents]');
        this.querySelector('[data-qw2-contents-text]').textContent = contents;
        line.hidden = !contents.trim();
        this.hidden = Array.from(this.children).every(child => child.hidden);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('qw2-product-details', ProductDetails);
})();
